import React from 'react';
import {obterAcoesDoAtorNaoVisualizadas, visualizarAção} from '../actions/AcaoActions';
import {connect} from 'react-redux';

class Notificacoes extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      loading:true
    };
  }
  componentWillMount(){
    let tipo = this.props.tipo;
    if(this.props.usuario.tipo === "administrador"){
        this.props.obterAcoesDoAtorNaoVisualizadas(null).then(()=>{
          this.setState({loading:false});
        });
    }else if(this.props.usuario.tipo === "comum"){
      this.props.obterAcoesDoAtorNaoVisualizadas(this.props.usuario.id).then(()=>{
        this.setState({loading:false});
      });
    }

  }
  visualizar(id){
    this.props.visualizarAção(id);
  }
  componentDidReceiveProps(){
  }
  render(){
    return(
      <div>
      <div className="nav-tabs-custom">
            <ul className="nav nav-tabs pull-right">
              <li className="active"><a href="#tab_1-1" data-toggle="tab" aria-expanded="false">Geral <span className="label label-success">{this.props.geral.length}</span></a></li>
              <li className=""><a href="#tab_2-2" data-toggle="tab" aria-expanded="false">Comissão <span className="label label-primary">{this.props.comissao.length}</span></a></li>
              <li className=""><a href="#tab_3-3" data-toggle="tab" aria-expanded="true">Atraso <span className="label label-danger">{this.props.atrazo.length}</span></a></li>
              <li className=""><a href="#tab_4-4" data-toggle="tab" aria-expanded="true">Finalização <span className="label label-warning">{this.props.finalizado.length}</span></a></li>
              <li className="pull-left header"><i className="fa fa-bell"></i>Notificações</li>
            </ul>
            <div className="tab-content">

              <div className="tab-pane active" id="tab_1-1">
                <div className="box-body" style={{maxHeight: this.props.altura + "px", overflowY: "auto"}}>
                  {this.props.geral &&  this.props.geral.length >0 ?
                    <table className="table table-hover table-striped table-condensed">
                      <tbody>
                        {
                          this.props.geral.map((notificacao)=>(
                            <tr key={notificacao.id}>
                              <td>{notificacao.texto}</td>
                              <td>{notificacao.contrato}</td>
                              <td>{new Date(notificacao.data).toLocaleDateString() + " - " + new Date(notificacao.data).toLocaleTimeString()}</td>
                              <td><button type="button" onClick={this.visualizar.bind(this,notificacao.id)} className="btn"><i className="fa fa-check"></i></button></td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    <div className="alert">
                      Nenhuma notificação disponivel.
                    </div>
                  }
                </div>
              </div>

              <div className="tab-pane" id="tab_2-2">
                <div className="box-body" style={{maxHeight: this.props.altura + "px", overflowY: "auto"}}>
                  {this.props.comissao &&  this.props.comissao.length >0 ?
                    <table className="table table-hover table-striped table-condensed">
                      <tbody>
                        {
                          this.props.comissao.map((notificacao)=>(
                            <tr key={notificacao.id}>
                              <td>{notificacao.texto}</td>
                              <td>{notificacao.contrato}</td>
                              <td>{new Date(notificacao.data).toLocaleDateString() + " - " + new Date(notificacao.data).toLocaleTimeString()}</td>
                              <td><button type="button" onClick={this.visualizar.bind(this,notificacao.id)} className="btn"><i className="fa fa-check"></i></button></td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    <div className="alert">
                      Nenhuma notificação disponivel.
                    </div>
                  }
                </div>
              </div>

              <div className="tab-pane " id="tab_3-3">
                <div className="box-body" style={{maxHeight: this.props.altura + "px", overflowY: "auto"}}>
                  {this.props.atrazo &&  this.props.atrazo.length >0 ?
                    <table className="table table-hover table-striped table-condensed">
                      <tbody>
                        {
                          this.props.atrazo.map((notificacao)=>(
                            <tr key={notificacao.id}>
                              <td>{notificacao.texto}</td>
                              <td>{notificacao.contrato}</td>
                              <td>{new Date(notificacao.data).toLocaleDateString() + " - " + new Date(notificacao.data).toLocaleTimeString()}</td>
                              <td><button type="button" onClick={this.visualizar.bind(this,notificacao.id)} className="btn"><i className="fa fa-check"></i></button></td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    <div className="alert">
                      Nenhuma notificação disponivel.
                    </div>
                  }
                </div>
              </div>

              <div className="tab-pane " id="tab_4-4">
                <div className="box-body" style={{maxHeight: this.props.altura + "px", overflowY: "auto"}}>
                  {this.props.finalizado &&  this.props.finalizado.length >0 ?
                    <table className="table table-hover table-striped table-condensed">
                      <tbody>
                        {
                          this.props.finalizado.map((notificacao)=>(
                            <tr key={notificacao.id}>
                              <td>{notificacao.texto}</td>
                              <td>{notificacao.contrato}</td>
                              <td>{new Date(notificacao.data).toLocaleDateString() + " - " + new Date(notificacao.data).toLocaleTimeString()}</td>
                              <td><button type="button" onClick={this.visualizar.bind(this,notificacao.id)} className="btn"><i className="fa fa-check"></i></button></td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    <div className="alert">
                      Nenhuma notificação disponivel.
                    </div>
                  }
                </div>
              </div>
            </div>

          </div>



       {this.state.loading ?
        <div className="overlay">
            <i className="fa fa-refresh fa-spin"></i>
        </div>
        :null
        }
      </div>

    );

  }
}
const mapStateToProps = (state) => {
  return {
    notificacoes:state.acoes.do_usuario,
    geral:state.acoes.nVisualizadoGeral,
    comissao:state.acoes.nVisualizadoComissao,
    atrazo:state.acoes.nVisualizadoAtrazo,
    finalizado:state.acoes.nVisualizadoFinalizados,
    usuario: state.usuario.autenticado,

  }
}

export default connect(mapStateToProps, {visualizarAção, obterAcoesDoAtorNaoVisualizadas })(Notificacoes);



// WEBPACK FOOTER //
// ./src/components/Notificacoes.js